(function () {
    'use strict';

    angular
        .module('app')
        .controller('TagUsageDialogCtrl', TagUsageDialogCtrl);

    TagUsageDialogCtrl.$inject = ['DialogInstance', 'linkedItems'];

    /**
     * @ngdoc Controller
     * @description
     * Dialog showing usage of tag(s).
     */
    function TagUsageDialogCtrl(DialogInstance, linkedItems) {
        /* jshint validthis:true */
        var vm = this;
        vm.linkedItems = linkedItems;
        vm.ok = ok;

        function ok() {
            DialogInstance.ok();
        }
    }
})();
